export function formatDateKey(date: Date) {
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  const d = date.getDate().toString().padStart(2, '0');
  return `${m}-${d}`;
}

export function getFirstSunday(year: number, month: number): Date {
  const d = new Date(year, month, 1);
  while (d.getDay() !== 0) d.setDate(d.getDate() + 1);
  return d;
}

export function getStartDay(year: number, month: number) {
  const date = new Date(year, month, 1);
  const day = date.getDay();
  return day === 0 ? 6 : day - 1; 
}

export function getDaysInMonth(year: number, month: number) {
  return new Date(year, month + 1, 0).getDate();
}

